export enum ShortPayCodes {
  productDeliveryVariance = 'DV',
  partialPayment = 'PP',
  productPricingVariance = 'PV',
  salesTaxVariance = 'TV',
  other = 'OT',
}
